import toError from 'transport/adapters/vod/parsers/error';
import * as http from 'transport/utils/http';
import { keysToCamelCase, keysToSnakeCase } from '@wix/wix-vod-shared/src/common/utils/object';

export default function initWidgets(settings) {
  const widgetsEndpoint = `${settings.apiUrl}/catalog/widgets`;
  const widgetsPublicEndpoint = `${settings.apiUrl}/public/widgets`;

  const update = (trigger, widgetId, data) =>
    http.put(`${widgetsEndpoint}/${widgetId}`, { data: keysToSnakeCase(data) })
      .then(keysToCamelCase)
      .catch(toError);

  const getSettings = (trigger, widgetId) =>
    http.get(`${widgetsPublicEndpoint}/${widgetId}/settings`)
      .then(keysToCamelCase)
      .catch(toError);

  const updateSettings = (trigger, widgetId, settings) =>
    http.put(`${widgetsEndpoint}/${widgetId}/settings`, { data: keysToSnakeCase(settings) })
      .then(keysToCamelCase)
      .catch(toError);

  const getDeeplinks = (trigger, listId) =>
    http.get(`${widgetsPublicEndpoint}/deeplinks?list_id=${listId}`)
      .then(keysToCamelCase)
      .catch(toError);

  const remove = (trigger, widgetId) =>
    http.del(`${widgetsEndpoint}/${widgetId}`)
      .catch(toError);

  return {
    update,
    getSettings,
    updateSettings,
    getDeeplinks,
    remove,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/widgets.js